import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '../../../../../core/services/language.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { environment } from '../../../../../../environments/environment';
import {
  PaymentTopupParkingPayload,
  PaymentTopupParkingResponse,
} from '../../../../../core/models/payment.model';
import { PssLoadingComponent } from "../../../../../tools/template/pss/pss-loading/pss-loading.component";
import { ParkingUserVehicleDto } from '../../../../../core/models/ev.model';
import { ToastWarnComponent } from "../../../../../tools/template/toast/toast-warn/toast-warn.component";
import { ToastFailedComponent } from "../../../../../tools/template/toast/toast-failed/toast-failed.component";
import { ToastSuccessComponent } from "../../../../../tools/template/toast/toast-success/toast-success.component";
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { CityParkingAccountTopUp } from '../../../../../core/models/topUpAccount.model';
import { ApiTopUpService } from '../../../../../core/services/api/Topup/api-topup';
import { ApiParkingService } from '../../../../../core/services/api/Parking/api-parking';

@Component({
  selector: 'app-check-amount-parking',
  imports: [CommonModule, FormsModule, PssLoadingComponent],
  templateUrl: './check-amount-parking.component.html',
  styleUrl: './check-amount-parking.component.css',
})
export class CheckAmountParkingComponent implements OnInit {
  currentLang: "TH" | "EN" = 'TH';
  sub!: Subscription;
  token: string = '';
  uid: string = '';
  // dataCard: any[] = [];
  // card_list : any = ['' , '' , '' , '' , ''];
  dataVehicle: ParkingUserVehicleDto[] = [];
  filteredDataVehicle: ParkingUserVehicleDto[] | null = null;
  selectedTransaction: ParkingUserVehicleDto | null = null;
  isLoading: boolean = false;
  obfuscatedCode: string = '';
  isOpenModalChose: boolean = false;
  isOpenModalQr: boolean = false;
  isOpenModalTopup: boolean = false;
  selectedId: string = '';
  searchText: string = '';
  topupAmount: CityParkingAccountTopUp = {
    amount: 0,
    accountName: '',
    accountNumber: '',
    userId: 0,
    status: 0
  };
  dateNow: Date = new Date();

  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false
  textWarn: string = ''
  detailWarn: string = ''
  isError: boolean = false
  textError: string = ''
  detailError: string = ''



  constructor(
    private router: Router,
    private languageService: LanguageService,
    private cookieService: CookieService,
    private apiTopUpService: ApiTopUpService,
    private apiParkingService: ApiParkingService,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService
  ) {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  ngOnInit(): void {
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';
    setTimeout(() => {
      this.getUserVehicle();
    }, 100);
    // this.getUserVehicle();
  }

  /* ----------------------------------- Function ------------------------------------- */
  /* --- Style --- */
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text)
  }
  showError(text: string, detail: string = '') {
    // this.toast.error(text);
    this.toastCustomService.showError('', text)
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.toastCustomService.showSuccess('', text)
  }

  get totalVehiclesCount(): number {
    return this.dataVehicle?.length || 0;
  }

  get totalPendingPayment(): number {
    if (!this.dataVehicle) return 0;
    return this.dataVehicle.reduce((acc, curr) => acc + (curr.totalPay || 0), 0);
  }

  /* --- Function --- */
  hour(totalTime: number) {
    return Math.floor(totalTime / 60);
  }
  getUserVehicle() {
    this.dataVehicle = [];
    if (this.uid) {
      this.isLoading = true;
      this.apiParkingService.getParkingUser(this.uid, this.token).subscribe({
        next: (response: ParkingUserVehicleDto[]) => {
          console.log('response data : ', response);
          this.isLoading = false;
          this.dataVehicle = response;
        },
        error: (err) => {
          console.error('โหลดบัตรสมาชิกล้มเหลว', err);
          this.isLoading = false;
        },
      });
    } else {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'ไม่พบ LINE uid กรุณาเข้าใหม่ผ่าน /register'
          : 'Missing LINE uid. Please re-enter via /register.'
      );
      this.router.navigate(['/home']);
      return;
    }
  }

  goback() {
    this.router.navigate(['/home']);
  }
  closeModal() {
    this.selectedId = '';
    this.isOpenModalChose = false;
    this.isOpenModalQr = false;
    this.isOpenModalTopup = false;
  }
  onClickPay(parking: ParkingUserVehicleDto) {

    this.isOpenModalChose = true;
    this.selectedTransaction = parking;
    console.log('selectedTransaction', this.selectedTransaction);
  }
  onSearch() {
    if (this.searchText === '') {
      this.filteredDataVehicle = null;
    }

    this.filteredDataVehicle = this.dataVehicle.filter((item) => {
      return item.entryLicense
        .toLowerCase()
        .includes(this.searchText.toLowerCase());
    });
    console.log('search', this.searchText);
  }
  onClearSearch() {
    this.searchText = '';
    console.log('clear search', this.searchText);
  }
  navigateToTopup() {
    if (this.selectedTransaction) {
      this.isOpenModalChose = false;
      this.getTopUpAccount();
    } else {
      console.log('No Selected');
    }
    // this.router.navigate(['/top-up'], {
    //   state: {
    //     cardCode: this.selectedId,
    //   },
    // });
  }
  navigateToQr() {
    // แปลงเลข cardCode เป็นตัวเลข
    const cardCodeNumber = parseInt(
      this.selectedTransaction ? this.selectedTransaction.cardCode : '0'
    );
    // แปลงฐาน 10 เป็นฐาน 16
    const encoded = cardCodeNumber.toString(16); // เข้ารหัสเป็นฐาน 16
    console.log('encoded : ', encoded, 'cardCodeNumber : ', cardCodeNumber);

    // ส่งข้อมูลไปยังหน้า QR Code
    const link = document.createElement('a');
    link.href = `${environment.webpayUrl}?data=${encoded}`;
    link.target = '_blank';
    link.click();
    this.isOpenModalChose = false;
  }
  navigateToQrParking(parking: ParkingUserVehicleDto) {
    this.selectedTransaction = parking
    // แปลงเลข cardCode เป็นตัวเลข
    const cardCodeNumber = parseInt(
      this.selectedTransaction ? this.selectedTransaction.cardCode : '0'
    );
    // แปลงฐาน 10 เป็นฐาน 16
    const encoded = cardCodeNumber.toString(16); // เข้ารหัสเป็นฐาน 16
    console.log('encoded : ', encoded, 'cardCodeNumber : ', cardCodeNumber);

    // ส่งข้อมูลไปยังหน้า QR Code
    const link = document.createElement('a');
    link.href = `${environment.webpayUrl}?data=${encoded}`;
    link.target = '_blank';
    link.click();
    this.isOpenModalChose = false;
  }
  paymentTopup() {
    // ตรวจสอบข้อมูลว่าการเลือก Transaction
    if (this.selectedTransaction) {
      // เช็คเงิน Top up ต้องมากกว่าค่าจอดรถ
      if (this.topupAmount.amount < this.selectedTransaction.totalPay) {
        this.showWarning(
          this.currentLang === 'TH'
            ? 'จำนวนเงินที่เติมต้องมากกว่าค่าจอดรถ'
            : 'The top-up amount must be greater than the parking fee.'
        );
        return;
      }
      // เตรียมข้อมูล ส่ง API เติมเงิน
      const payload: PaymentTopupParkingPayload = {
        uid: this.uid,
        siteId: this.selectedTransaction.siteId,
        seq: this.selectedTransaction.seq,
        parkingfee:
          this.selectedTransaction.parkingFee -
          this.selectedTransaction.paidParking,
        penaltyFee:
          this.selectedTransaction.penaltyFee -
          this.selectedTransaction.paidPenalty,
        totalPay: this.selectedTransaction.totalPay,
        topupAmount: this.topupAmount.amount,
        subscriptId: this.selectedTransaction.subscriptId,
        providerId: this.selectedTransaction.providerId,
      };

      console.log('payload top up : ', JSON.stringify(payload));
      // เรียกใช้ API เติมเงิน
      if (payload) {
        this.isLoading = true;
        this.sentPaymentTopupParking(payload);
      } else {
        console.log('No payload');
      }

    } else {
      console.log('No Selected');
      this.showWarning(
        this.currentLang === 'TH'
          ? 'ไม่พบข้อมูล กรุณาลองใหม่อีกครั้ง'
          : 'Data not found, please try again.'
      );
      this.isLoading = false;
    }
  }

  /* -------------------------------------------- API ------------------------------------------ */
  getTopUpAccount() {
    this.isLoading = true;
    this.apiTopUpService.getTopUpAccount(this.uid, this.token).subscribe({
      next: (response: CityParkingAccountTopUp) => {
        console.log('response top up modal  : Amount Top Up : ', response);
        this.isLoading = false;
        const now = new Date();
        this.dateNow = now;
        this.isOpenModalTopup = true;
        this.topupAmount = response;
      },
      error: (err) => {
        console.error('โหลดข้อมูล top up modal ล้มเหลว', err);
        this.isLoading = false;
      },
    });
  }
  sentPaymentTopupParking(payload: PaymentTopupParkingPayload) {
    this.apiTopUpService.sentApiPaymentTopupParking(payload, this.token).subscribe({
      next: (response: PaymentTopupParkingResponse) => {
        console.log('response top up payment : ', response);

        if (response.code === '000') {
          this.isLoading = false;
          this.showSuccess(
            this.currentLang === 'TH'
              ? response.message
              : response.message_en
          );
          this.isOpenModalTopup = false;
          this.isOpenModalChose = false;
          this.selectedTransaction = null;
          this.getUserVehicle();
        }
        else {
          this.isLoading = false;
          this.showError(
            this.currentLang === 'TH'
              ? response.message
              : response.message_en
          );
        }
      },
      error: (err) => {
        console.error('ส่งข้อมูล top up payment ล้มเหลว', err);
        this.isLoading = false;
        this.showError(
          this.currentLang === 'TH'
            ? 'ส่งข้อมูลล้มเหลว กรุณาลองใหม่อีกครั้ง'
            : 'Data submission failed, please try again.'
        );
      }
    });
  }
}
